/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: "M12.3687 17C12.7524 16.8512 13.044 16.6122 12.9845 16.1576C12.9592 15.9646 12.8507 15.7562 12.7207 15.6077C11.7177 14.462 10.7001 13.3291 9.68694 12.1924C8.61387 10.9884 7.54066 9.78457 6.46777 8.58049C6.44829 8.5586 6.43163 8.53409 6.40023 8.49339C6.81846 8.02347 7.23566 7.55426 7.6533 7.08546C9.34494 5.18689 11.0357 3.2875 12.7299 1.39124C12.9263 1.17138 13.0384 0.930263 12.9879 0.632714C12.9277 0.278233 12.6129 0.00695639 12.2166 0.00492148C10.6944 -0.00290163 9.1721 0.000173351 7.64985 0.00342921C7.39671 0.00397185 7.19597 0.127514 7.02842 0.31563C5.26244 2.29872 3.49543 4.28086 1.72864 6.26318C1.24945 6.8008 0.771166 7.3391 0.290727 7.8755C-0.0993299 8.31102 -0.0963745 8.68875 0.296459 9.12924C2.52335 11.626 4.74729 14.1253 6.9792 16.6174C7.11818 16.7726 7.31619 16.8737 7.48678 17H12.3687Z",
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on( 'settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;